<template>
  <div class="projectPage">
                    <div class="projectHeader">
                        <div class="projectTitle">
                            <div class="leftHeader">
                                <div id="projectDetailBtn" class="simpleBtn">
                                    <i class="bi bi-three-dots-vertical"></i>
                                </div>
                                <div class="projectName">
                                    <i class="bi bi-app"></i>
                                    <span>{{projectInfo.Name}}</span>
                                </div>
                            </div>
                            <div class="rightHeader">
                                <button class="grayBtn">
                                    <i class="bi bi-person-add"></i>
                                    <span>초대하기</span>
                                </button>
                            </div>
                        </div>
                        <div class="projectMenu">
                          <div id="feed" class="projectMenuItem" @click="navigateProjectMenu('feed')">피드</div>
                          <div id="task" class="projectMenuItem" @click="navigateProjectMenu('task')">업무</div>
                          <div id="calendar" class="projectMenuItem active" @click="navigateProjectMenu('calendar')">캘린더</div>
                          <div id="file" class="projectMenuItem" @click="navigateProjectMenu('file')">파일</div>
                        </div>
                    </div>
                    <div class="projectCalendarPageContainer">
                        <div class="projectCalendarPage">
                          <div class="projectCalendarHeader">
                            <!-- 필터검색 : .open <-> .close -->
                            <div class="filterPanelBox" :class="{ open: isFilterOpen, close: !isFilterOpen }"> 
                              <div class="filterPanelContainer">
                                <div class="filterPanelHeader">
                                  <span>필터</span>
                                </div>
                                <div class="filterPanelBody">
                                  <!-- .filterPanelItemBox 클릭시 .active on/off -->
                                  <div class="filterPanelItemBox scheduleFilter active">
                                    <div class="filterPanelItemTitle">
                                      <span>일정</span>
                                      <i class="bi bi-chevron-up"></i>
                                    </div>
                                    <div class="filterPanelItemList">
                                      <div class="filterInputItem radioItem">
                                        <input type="radio" name="scheduleFilter" id="radioOption1">
                                        <label for="radioOption1">전체 일정</label>
                                      </div>
                                      <div class="filterInputItem radioItem">
                                        <input type="radio" name="scheduleFilter" id="radioOption2">
                                        <label for="radioOption2">내 일정</label>
                                      </div>
                                      <div class="filterInputItem radioItem">
                                        <input type="radio" name="scheduleFilter" id="radioOption3">
                                        <label for="radioOption3">등록한 일정</label>
                                      </div>
                                      <div class="filterInputItem radioItem">
                                        <input type="radio" name="scheduleFilter" id="radioOption4">
                                        <label for="radioOption4">선택안함</label>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="filterPanelItemBox projectFilter active">
                                    <div class="filterPanelItemTitle">
                                      <span>업무</span>
                                      <i class="bi bi-chevron-up"></i>
                                    </div>
                                    <div class="filterPanelItemList">
                                      <div class="filterInputItem radioItem">
                                        <input type="radio" name="projectFilter" id="radioOption5">
                                        <label for="radioOption5">전체 업무</label>
                                      </div>
                                      <div class="filterInputItem radioItem">
                                        <input type="radio" name="projectFilter" id="radioOption6">
                                        <label for="radioOption6">내가 담당한 업무</label>
                                      </div>
                                      <div class="filterInputItem radioItem">
                                        <input type="radio" name="projectFilter" id="radioOption7">
                                        <label for="radioOption7">내가 요청한 업무</label>
                                      </div>
                                      <div class="filterInputItem radioItem">
                                        <input type="radio" name="projectFilter" id="radioOption8">
                                        <label for="radioOption8">선택안함</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="filterPanelBtn" @click="toggleFilter">
                                <span>필터</span>
                                <i class="bi bi-chevron-right"></i>
                              </div>  
                            </div>
                            <div class="projectListHeaderLeft">
                              <div class="projectSearch formRightIcon">
                                <input type="search" name="projectSearch" id="projectSearch" v-model="searchSubject" ref="searchSubject" placeholder="일정명을 검색해주세요">
                                <span class="formIcon">
                                  <i class="bi bi-search"></i>
                                </span>
                              </div>
                            </div>
                            <div class="projectListHeaderRight">
                              <div class="addBtnBox">
                                <button class="biglineBtn blueBtn"  @click="showAddSchedulePopup = true">
                                  <i class="bi bi-plus-lg"></i>
                                  <span>일정 추가</span>
                                </button>
                              </div>
                            </div>
                          </div>

                          <div class="projectCalendarBody">
                            <div class="projectCalenderBodyHeader">
                              <div class="projectBodyHeaderLeft">
                                <!-- 이전 달 -->
                                <div class="lineBtn" @click="goPrevMonth">
                                  <i class="bi bi-chevron-left"></i>
                                </div>

                                <!-- 현재 년/월 표시 -->
                                <div class="calendarTitle">
                                  <span>{{ calendarTitle }}</span>
                                </div>

                                <!-- 다음 달 -->
                                <div class="lineBtn" @click="goNextMonth">
                                  <i class="bi bi-chevron-right"></i>
                                </div>
                              </div>

                              <!-- 오늘 버튼 -->
                              <div class="projectBodyHeaderRight">
                                <div class="todayBtnBox">
                                  <button class="biglineBtn" @click="goToday">
                                    <i class="bi bi-calendar-event"></i>
                                    <span>오늘</span>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- 요일 헤더 -->
                            <div class="projectCalender">
                              <div class="calendarWeekTitle">
                                <div class="c-sun">일요일</div>
                                <div>월요일</div>
                                <div>화요일</div>
                                <div>수요일</div>
                                <div>목요일</div>
                                <div>금요일</div>
                                <div class="c-sat">토요일</div>
                              </div>

                              <!-- 날짜 그리드 -->
                              <div class="calendarBodyContainer">
                                <div
                                  class="calendarRow"
                                   v-for="(renderWeek, weekIndex) in calendarRenderWeeks" :key="weekIndex"
                                >
                                  <div class="calendarRowGrid">
                                    <div v-for="n in 7" :key="n"></div>
                                  </div>

                                  <table class="calendarContent">
                                    <thead>
                                      <tr>
                                        <td
                                          v-for="(day, dIndex) in renderWeek.days"
                                          :key="`day-${weekIndex}-${dIndex}`"
                                          :class="{
                                            'c-sun': dIndex === 0,
                                            'c-sat': dIndex === 6,
                                            'c-opacity': day === null
                                          }"
                                        >
                                          <span v-if="day">{{ day }}</span>
                                        </td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(row, rowIndex) in renderWeek.rows" :key="`row-${weekIndex}-${rowIndex}`">
                                        <template v-for="td in generateRowTds(row)" :key="td.key">
                                          <!-- 일정 표시 -->
                                          <td v-if="td.type === 'bar'" :colspan="td.colspan" class="c-event-red">
                                            <span>
                                              <b>{{ td.event.alldayYN === 'Y' ? '종일' : formatTime(td.event.startDtm) }}</b>
                                              {{ td.event.subject }}
                                            </span>
                                          </td>

                                          <!-- +N개 표시 -->
                                          <td v-else-if="td.type === 'more'" :colspan="td.colspan" class="c-more">
                                            <span><b>+ {{ td.count }}개</b></span>
                                          </td>

                                          <!-- 덮인 칸 -->
                                          <td v-else-if="td.type === 'skip'" class="c-skip"></td>

                                          <!-- 빈칸 -->
                                          <td v-else></td>
                                        </template>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="projectCalendarBody">
                            <div class="projectCalenderBodyHeader">
                              <div class="projectBodyHeaderLeft">
                                <div class="lineBtn">
                                  <i class="bi bi-chevron-left"></i>
                                </div>
                                <div class="calendarTitle">
                                  <span>2025년 7월</span>
                                </div>
                                <div class="lineBtn">
                                  <i class="bi bi-chevron-right"></i>
                                </div>
                              </div>
                              <div class="projectBodyHeaderRight">
                                <div class="todayBtnBox">
                                  <button class="biglineBtn">
                                    <i class="bi bi-calendar-event"></i>
                                    <span>오늘</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="projectCalender">
                              <div class="calendarWeekTitle">
                                <div class="c-sun">일요일</div>
                                <div>월요일</div>
                                <div>화요일</div>
                                <div>수요일</div>
                                <div>목요일</div>
                                <div>금요일</div>
                                <div class="c-sat">토요일</div>
                              </div>
                              <div class="calendarBodyContainer">
                                <div class="calendarRow">
                                  <div class="calendarRowGrid">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                  </div>
                                  <table class="calendarContent">
                                    <thead>
                                      <tr>
                                        <td class="c-sun c-opacity"><span>29</span></td>
                                        <td class="c-opacity"><span>30</span></td>
                                        <td><span>1</span></td>
                                        <td><span>2</span></td>
                                        <td><span>3</span></td>
                                        <td><span>4</span></td>
                                        <td class="c-sat"><span>5</span></td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td colspan="1" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td class="c-more"><span><b>+ 2개</b></span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="calendarRow">
                                  <div class="calendarRowGrid">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                  </div>
                                  <table class="calendarContent">
                                    <thead>
                                      <tr>
                                        <td class="c-sun"><span>6</span></td>
                                        <td><span>7</span></td>
                                        <td><span>8</span></td>
                                        <td><span>9</span></td>
                                        <td><span>10</span></td>
                                        <td><span>11</span></td>
                                        <td class="c-sat"><span>12</span></td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-red"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-gray"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td class="c-more"><span><b>+ 2개</b></span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="calendarRow">
                                  <div class="calendarRowGrid">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                  </div>
                                  <table class="calendarContent">
                                    <thead>
                                      <tr>
                                        <td class="c-sun"><span>13</span></td>
                                        <td><span>14</span></td>
                                        <td><span>15</span></td>
                                        <td class="c-today"><span>16</span></td>
                                        <td><span>17</span></td>
                                        <td><span>18</span></td>
                                        <td class="c-sat"><span>19</span></td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td class="c-more"><span><b>+ 2개</b></span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="calendarRow">
                                  <div class="calendarRowGrid">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                  </div>
                                  <table class="calendarContent">
                                    <thead>
                                      <tr>
                                        <td class="c-sun"><span>20</span></td>
                                        <td><span>21</span></td>
                                        <td><span>22</span></td>
                                        <td><span>23</span></td>
                                        <td><span>24</span></td>
                                        <td><span>25</span></td>
                                        <td class="c-sat"><span>26</span></td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td class="c-more"><span><b>+ 2개</b></span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="calendarRow">
                                  <div class="calendarRowGrid">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                  </div>
                                  <table class="calendarContent">
                                    <thead>
                                      <tr>
                                        <td class="c-sun"><span>27</span></td>
                                        <td><span>28</span></td>
                                        <td><span>29</span></td>
                                        <td><span>30</span></td>
                                        <td><span>31</span></td>
                                        <td class="c-opacity"><span>1</span></td>
                                        <td class="c-sat c-opacity"><span>2</span></td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td colspan="2" class="c-event-blue"><span><b>오후 10:00</b>일정명입니다</span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td class="c-more"><span><b>+ 2개</b></span></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div> -->
                        </div>
                    </div>
                </div>

                <!-- 글 작성 모달 -->
                <div class="modalBg createTextFeed " v-show="showAddPostPopup">
                    <div class="modalBox createTextFeedBox">
                        <div class="modalHeader">
                            <div class="modalTitleBox">
                                <div class="modalTitle">
                                    <h5>게시물 작성</h5>
                                    <span class="gap"></span>
                                    <span class="modalchangeProjectBox">
                                        <i class="bi bi-chevron-down"></i>
                                        <div class="selectedProject">
                                            <i class="bi bi-app"></i><span>{{this.projectName}}</span>
                                        </div>
                                    </span>
                                </div>
                                <div class="modalHeaderBtnBox">
                                    <span class="dashBtn"><i class="bi bi-dash-lg"></i></span>
                                    <span class="closeBtn" @click="showAddPostPopup = false;initPostPopupVaule();"><i class="bi bi-x-lg"></i></span>
                                </div>
                            </div>
                            <div class="modalMenu">
                                <div class="selectCategory">
                                    <div class="simpleBtn simple55Btn active" @click="initAllPopup('post')">
                                        <i class="bi bi-file-earmark-text"></i>
                                        <span>글</span>
                                    </div>
                                    <div class="simpleBtn simple55Btn" @click="initAllPopup('task')">
                                        <i class="bi bi-card-list"></i>
                                        <span>업무</span>
                                    </div>
                                    <div class="simpleBtn simple55Btn" @click="initAllPopup('schedule')">
                                        <i class="bi bi-calendar-week"></i>
                                        <span>일정</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modalBody">
                            <div class="modalFeedTitleInputBox">
                                <input type="text" class="modalFeedTitleInput" v-model="postSubject" ref="postSubject" placeholder="제목을 작성하세요." >
                            </div>
                            <div class="modalFeedDesInputBox">
                                <textarea name="" id="" class="modalFeedDesInput" v-model="postContent" ref="postContent" placeholder="내용을 작성하세요."></textarea>
                            </div>
                        </div>
                        <div class="modalFooter">
                            <div class="modalFooterBtnBox">
                                <div class="btnBox">
                                    <i class="bi bi-fonts"></i>
                                    <i class="bi bi-paperclip"></i>
                                    <i class="bi bi-geo-alt"></i>
                                </div>
                            </div>
                            <div class="modalFooterBtnBox">
                                <div class="dropdown">
                                    <div class="dropdown-button" @click="toggleDropdown">{{ selectedOption }}</div>
                                    <div class="dropdown-menu" v-show="isDropdownOpen">
                                        <div class="dropdown-item" @click="selectItem('전체공개')">전체공개</div>
                                        <div class="dropdown-item" @click="selectItem('프로젝트 관리자만')">프로젝트 관리자만</div>
                                    </div>
                                </div>
                                <div class="preStorage">
                                    <span>임시저장</span>
                                    <span class="gap"></span>
                                    <span><b>0</b></span>
                                </div>
                                <button class="blueBtn" @click="addPost">등록</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 업무 작성 모달 -->
                <div class="modalBg createTaskFeed " v-show="showAddTaskPopup">
                    <div class="modalBox createTaskFeedBox">
                        <div class="modalHeader">
                            <div class="modalTitleBox">
                                <div class="modalTitle">
                                    <h5>게시물 작성</h5>
                                    <span class="gap"></span>
                                    <span class="modalchangeProjectBox">
                                        <i class="bi bi-chevron-down"></i>
                                        <div class="selectedProject">
                                            <i class="bi bi-app"></i><span>{{this.projectName}}</span>
                                        </div>
                                    </span>
                                </div>
                                <div class="modalHeaderBtnBox">
                                    <span class="dashBtn"><i class="bi bi-dash-lg"></i></span>
                                    <span class="closeBtn" @click="showAddTaskPopup = false;initTaskPopupVaule();"><i class="bi bi-x-lg"></i></span>
                                </div>
                            </div>
                            <div class="modalMenu">
                                <div class="selectCategory">
                                    <div class="simpleBtn simple55Btn" @click="initAllPopup('post')">
                                        <i class="bi bi-file-earmark-text"></i>
                                        <span>글</span>
                                    </div>
                                    <div class="simpleBtn simple55Btn active" @click="initAllPopup('task')">
                                        <i class="bi bi-card-list"></i>
                                        <span>업무</span>
                                    </div>
                                    <div class="simpleBtn simple55Btn" @click="initAllPopup('schedule')">
                                        <i class="bi bi-calendar-week"></i>
                                        <span>일정</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modalBody">
                            <div class="modalFeedTitleInputBox">
                                <input type="text" class="modalFeedTitleInput" v-model="taskSubject" ref="taskSubject" placeholder="제목을 작성하세요.">
                            </div>
                            <div class="modalFeedDetailItemBox">

                                <div class="detailItem status">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-bar-chart-steps"></i>
                                    </div>
                                    <div class="detailItemDes">
                                        <div class="statusBtnBox">
                                            <div class="statusBtn request" :class="{ active: selectedTaskStatus === 'R' }" @click="selectedTaskStatus = 'R'">요청</div>
                                            <div class="statusBtn inProgress" :class="{ active: selectedTaskStatus === 'P' }" @click="selectedTaskStatus = 'P'">진행</div>
                                            <div class="statusBtn feedback" :class="{ active: selectedTaskStatus === 'F' }" @click="selectedTaskStatus = 'F'">피드백</div>
                                            <div class="statusBtn completed" :class="{ active: selectedTaskStatus === 'C' }" @click="selectedTaskStatus = 'C'">완료</div>
                                            <div class="statusBtn onHold" :class="{ active: selectedTaskStatus === 'H' }" @click="selectedTaskStatus = 'H'">보류</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="detailItem manager">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-person"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <!-- ▼ 담당자 추가 시 생성 ▼ -->
                                        <div class="detailItemDes" v-if="selectedTaskManager">
                                            <div class="selectedUser">
                                                <div class="userInfo">
                                                    <div class="specialUserImg">
                                                        <img :src="selectedTaskManager.managerUserPhoto ? 
                                                        `https://mizecloud-partners.co.kr/employee_img/${selectedTaskManager.managerUserPhoto}` : 'https://mizecloud-partners.co.kr/employee_img/default.png'" alt="userProfileImg"/>
                                                    </div>
                                                    <div class="specialUserName">{{ selectedTaskManager.managerUserName }}</div>
                                                </div>
                                                <span class="xBtn" @click="selectedTaskManager = ''"><i class="bi bi-x-lg"></i></span>
                                            </div>
                                        </div>
                                        <span class="underlineBtn" @click="searchManagerName = ''; isManagerPopupOpen = !isManagerPopupOpen" v-if="!selectedTaskManager">담당자 추가</span>
                                        <!-- ▼ 담당자 추가 시 class="active" 추가 -> 나타남 -->
                                        <div class="peopleSelectBox" :class="{ active: isManagerPopupOpen }">
                                            <div class="peopleSearch formRightIcon">
                                                <input type="text" :value="searchManagerName" @input="handleManagerInput" id="peopleSearch" placeholder="검색어를 입력해주세요"/>
                                                <span class="formIcon">
                                                    <i class="bi bi-search"></i>
                                                </span>
                                            </div>
                                            <div class="peopleListBox">
                                            <div class="peopleList" ref="peopleList">
                                                <div class="peopleItem" v-for="person in searchManagerUserList" :key="person.managerUserId" @click="selectTaskManager(person)">
                                                    <div class="specialUserInfo">
                                                    <div class="specialUserImg">
                                                        <img
                                                            :src="
                                                            person.managerUserPhoto
                                                                ? `https://mizecloud-partners.co.kr/employee_img/${person.managerUserPhoto}`
                                                                : 'https://mizecloud-partners.co.kr/employee_img/default.png'
                                                            "
                                                            alt="profileImg"
                                                        />
                                                    </div>
                                                    <div class="specialUserDes">
                                                        <div class="specialUserName">
                                                        {{ person.managerUserName }} <span>{{ person.managerUserPosition }}</span>
                                                        </div>
                                                        <div class="specialUserTeam">{{ person.managerUserDept }}</div>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div v-if="searchManagerUserList.length === 0 && searchManagerName.trim() !== ''" class="noResult">
                                                    검색 결과가 없습니다.
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- ▼▼▼ + 항목추가입력 시 생성 ▼▼▼ -->
                                <div class="detailItem startDate">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-calendar"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <!-- ▼ 시작일 추가 시 생성 ▼ -->
                                        <div class="detailItemDes" v-if="selectedTaskStartDate">
                                            <div class="textBox">
                                                <span>{{ formattedTaskStartDate }}</span>
                                                <span class="xBtn" @click="selectedTaskStartDate = null"><i class="bi bi-x-lg"></i></span>
                                            </div>
                                        </div>
                                        <span class="underlineBtn" @click="isTaskStartDatePickerOpen = true" v-if="!selectedTaskStartDate">시작일 추가</span>
                                        <DatePicker
                                            :value="selectedTaskStartDate"
                                            @change="handleTaskStartDateChange"
                                            v-model:open="isTaskStartDatePickerOpen"
                                        >
                                            <template #input></template>                        
                                            <template #icon-calendar></template>
                                        </DatePicker>
                                    </div>
                                </div>
                                
                                <div class="detailItem endDate">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-calendar"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <!-- ▼ 마감일 추가 시 생성 ▼ -->
                                        <div class="detailItemDes" v-if="selectedTaskEndDate">
                                            <div class="textBox">
                                                <span>{{ formattedTaskEndDate }}</span>
                                                <span class="xBtn" @click="selectedTaskEndDate = null"><i class="bi bi-x-lg"></i></span>
                                            </div>
                                        </div>
                                        <span class="underlineBtn" @click="isTaskEndDatePickerOpen = true" v-if="!selectedTaskEndDate">마감일 추가</span>
                                        <DatePicker
                                            :value="selectedTaskEndDate"
                                            @change="handleTaskEndDateChange"
                                            v-model:open="isTaskEndDatePickerOpen"
                                        >
                                            <template #input></template>                        
                                            <template #icon-calendar></template>
                                        </DatePicker>
                                    </div>
                                </div>

                                <!-- ▼▼▼ + 항목추가입력 시 생성 ▼▼▼ -->
                                <div class="detailItem priority" v-if="isPriorityProgressOpen">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-flag"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <!-- ▼ 우선순위 추가 시 생성 ▼ -->
                                        <div class="detailItemDes" v-if="selectedPriority">
                                            <div class="textBox">
                                                <span class="simpleBtn notBtn" :class="selectedPriority.class">
                                                    <i class="bi" :class="selectedPriority.icon"></i>
                                                    <span>{{ selectedPriority.text }}</span>
                                                </span>
                                                <span class="xBtn" @click="selectedPriority = null; isPriorityPopupOpen = false;">
                                                    <i class="bi bi-x-lg"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <span class="underlineBtn" @click="isPriorityPopupOpen = true" v-if="!selectedPriority">우선순위 추가</span>
                                        <!-- ▼ 우선순위 추가 시 class="active" 추가 -> 나타남 -->
                                        <div class="prioritySelectBox" :class="{ active: isPriorityPopupOpen }">
                                            <div 
                                                v-for="priority in priorities" 
                                                :key="priority.id"
                                                class="simpleBtn"
                                                :class="priority.class"
                                                @click="selectPriority(priority)"
                                            >
                                                <i class="bi" :class="priority.icon"></i>
                                                <span>{{ priority.text }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- ▼▼▼ + 항목추가입력 시 생성 ▼▼▼ -->
                                <div class="detailItem progress" v-if="isPriorityProgressOpen">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-segmented-nav"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <div class="detailItemDes">
                                            <div class="progressBox">
                                                <input type="range" min="0" max="100" :value="taskProgress" @input="updateTaskProgress" />
                                                <span>{{ taskProgress }}%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="subTaskListBox">
                                    <button class="biglineBtn" @click="isPriorityProgressOpen = true;" v-if="!isPriorityProgressOpen">
                                        <i class="bi bi-plus-lg"></i>
                                        <span>항목추가입력</span>
                                    </button>
                                </div>
                            </div>
                            <div class="modalFeedDesInputBox">
                                <textarea name="" id="" class="modalFeedDesInput" v-model="taskContent" ref="taskContent" placeholder="내용을 작성하세요."></textarea>
                            </div>
                            <div class="">
                                <div class="feedBodySubTaskBox">
                                    <div class="subTaskTitleBox">
                                        <span class="subTaskIcon"><i class="bi bi-list-task"></i></span>
                                        <span class="subTaskTitle">하위업무</span>
                                    </div>
                                    <div class="subTaskListBox">
                                        <div class="subTaskListItem" v-for="subTask in subTaskList" :key="subTask.id">
                                            <div class="subTaskInfo">
                                                <span class="statusBtnSmall request">{{ statusMap[subTask.status] }}</span>
                                                <span class="subTaskTxt">
                                                    <input type="text" v-model="subTask.name" placeholder="업무명 입력" @keyup.enter="handleEnter(subTask)" :ref="'subtask_' + subTask.id">
                                                </span>
                                            </div>
                                            <div class="subTaskInfo" style="position: relative;">
                                                <span class="circleBtn" @click="toggleDatePicker(subTask)">
                                                    <i class="bi bi-calendar" :style="subTask.subTaskEndDate ? 'color: #007bff;' : ''"></i>
                                                </span>
                                                <span class="circleBtn" @click="togglePriorityPopup(subTask)">
                                                    <i class="bi" :class="subTask.selectedSubTaskPriority ? subTask.selectedSubTaskPriority.icon : 'bi-caret-down-fill'"
                                                    :style="{ color: subTask.selectedSubTaskPriority ? subTask.selectedSubTaskPriority.color : '' + ' !important' }"></i>
                                                </span>
                                                <span class="circleBtn" @click="toggleManagerPopup(subTask)">
                                                    <img
                                                        v-if="subTask.selectedSubTaskManager"
                                                        :src="subTask.selectedSubTaskManager.managerUserPhoto ? `https://mizecloud-partners.co.kr/employee_img/${subTask.selectedSubTaskManager.managerUserPhoto}` : 'https://mizecloud-partners.co.kr/employee_img/default.png'"
                                                        alt="profileImg"
                                                        class="profile-thumbnail" style="border-radius: 50%;"
                                                    />
                                                    <i v-else class="bi bi-person"></i>
                                                </span>
                                                <span v-if="subTask.isDatePickerOpen">
                                                    <DatePicker
                                                        :value="subTask.subTaskEndDate"
                                                        @change="subTask.subTaskEndDate = $event; subTask.isDatePickerOpen = false;"
                                                        :teleport="true"
                                                        :auto-apply="true"
                                                        inline
                                                    />
                                                </span>
                                                
                                                <div class="prioritySelectBox" v-if="subTask.isSubTaskPriorityPopupOpen" 
                                                    style="position: absolute !important;top:100% !important;right:0 !important;z-index:9999 !important; display: block !important;">
                                                    <div 
                                                        v-for="priority in subTaskPriorities" 
                                                        :key="priority.id"
                                                        class="simpleBtn"
                                                        :class="priority.class"
                                                        @click="selectSubTaskPriority(subTask, priority)"
                                                    >
                                                        <i class="bi" :class="priority.icon"></i>
                                                        <span>{{ priority.text }}</span>
                                                    </div>
                                                </div>

                                                <div class="peopleSelectBox" v-if="subTask.isSubTaskManagerPopupOpen" 
                                                    style="position: absolute !important;top:100% !important;right:0 !important;z-index:9999 !important; display: block !important;">
                                                    <div class="peopleSearch formRightIcon">
                                                        <input type="text" :value="searchManagerName" @input="handleManagerInput" id="peopleSearch" placeholder="검색어를 입력해주세요"/>
                                                        <span class="formIcon">
                                                            <i class="bi bi-search"></i>
                                                        </span>
                                                    </div>
                                                    <div class="peopleListBox">
                                                        <div class="peopleList" ref="peopleList">
                                                            <div class="peopleItem" v-for="person in searchManagerUserList" :key="person.managerUserId" @click="selectSubTaskManager(subTask, person)">
                                                                <div class="specialUserInfo">
                                                                    <div class="specialUserImg">
                                                                        <img
                                                                            :src="person.managerUserPhoto ? `https://mizecloud-partners.co.kr/employee_img/${person.managerUserPhoto}` : 'https://mizecloud-partners.co.kr/employee_img/default.png'"
                                                                            alt="profileImg"
                                                                        />
                                                                    </div>
                                                                    <div class="specialUserDes">
                                                                        <div class="specialUserName">
                                                                            {{ person.managerUserName }} <span>{{ person.managerUserPosition }}</span>
                                                                        </div>
                                                                        <div class="specialUserTeam">{{ person.managerUserDept }}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-if="searchManagerUserList.length === 0 && searchManagerName.trim() !== ''" class="noResult">
                                                                검색 결과가 없습니다.
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>                        
                                    <div class="subTaskListBox">
                                        <button class="biglineBtn" @click="addSubTask">
                                            <i class="bi bi-plus-lg"></i>
                                            <span>하위업무 추가</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modalFooter">
                            <div class="modalFooterBtnBox">
                                <div class="btnBox">
                                    <i class="bi bi-fonts"></i>
                                    <i class="bi bi-paperclip"></i>
                                    <i class="bi bi-geo-alt"></i>
                                </div>
                            </div>
                            <div class="modalFooterBtnBox">
                                <div class="dropdown">
                                    <div class="dropdown-button" @click="toggleDropdown">{{ selectedOption }}</div>
                                    <div class="dropdown-menu" v-show="isDropdownOpen">
                                        <div class="dropdown-item" @click="selectItem('전체공개')">전체공개</div>
                                        <div class="dropdown-item" @click="selectItem('프로젝트 관리자만')">프로젝트 관리자만</div>
                                    </div>
                                </div>
                                <div class="preStorage">
                                    <span>임시저장</span>
                                    <span class="gap"></span>
                                    <span><b>0</b></span>
                                </div>
                                <button class="blueBtn" @click="addTask">등록</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 일정 작성 모달 / 일정 추가 클릭시 .active -->
                <div class="modalBg createScheduleFeed" v-show="showAddSchedulePopup"> 
                    <div class="modalBox createTextFeedBox">
                        <div class="modalHeader">
                            <div class="modalTitleBox">
                                <div class="modalTitle">
                                    <h5>게시물 작성</h5>
                                    <span class="gap"></span>
                                    <span class="modalchangeProjectBox">
                                        <i class="bi bi-chevron-down"></i>
                                        <div class="selectedProject">
                                            <i class="bi bi-app"></i><span>{{this.projectName}}</span>
                                        </div>
                                    </span>
                                </div>
                                <div class="modalHeaderBtnBox">
                                    <span class="dashBtn"><i class="bi bi-dash-lg"></i></span>
                                    <span class="closeBtn" @click="showAddSchedulePopup = false;initSchedulePopupVaule();"><i class="bi bi-x-lg"></i></span>
                                </div>
                            </div>
                            <div class="modalMenu">
                                <div class="selectCategory">
                                    <div class="simpleBtn simple55Btn" @click="initAllPopup('post')">
                                        <i class="bi bi-file-earmark-text"></i>
                                        <span>글</span>
                                    </div>
                                    <div class="simpleBtn simple55Btn" @click="initAllPopup('task')">
                                        <i class="bi bi-card-list"></i>
                                        <span>업무</span>
                                    </div>
                                    <div class="simpleBtn simple55Btn active" @click="initAllPopup('schedule')">
                                        <i class="bi bi-calendar-week"></i>
                                        <span>일정</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modalBody">
                            <div class="modalFeedTitleInputBox">
                                <input type="text" class="modalFeedTitleInput" v-model="scheduleSubject" ref="scheduleSubject" placeholder="제목을 작성하세요.">
                            </div>
                            <div class="modalFeedDetailItemBox">

                                <div class="detailItem scheduleDateTime">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-calendar"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <div class="detailItemDes">
                                            <div class="dateBox">
                                                <input type="datetime-local" name="" id="startDateTime" v-model="scheduleStartDateTime" ref="scheduleStartDateTime" @input="handleScheduleStartDateChange">
                                                <span><i class="bi bi-dash-lg"></i></span>
                                                <input type="datetime-local" name="" id="endDateTime" v-model="scheduleEndDateTime" ref="scheduleEndDateTime" @input="handleScheduleEndDateChange">
                                            </div>
                                        </div> 
                                        <label class="checkboxBox" @click="checkAllDayClick">
                                            <input type="checkbox" name="" id="" v-model="isAllDay" :disabled="!canCheckAllDay" true-value="Y" false-value="N">
                                            <span>종일</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="detailItem manager">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-person"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <div class="detailItemDes" v-if="selectedParticipantUserList.length">
                                            <div class="selectedUser" v-for="(participantUser, index) in selectedParticipantUserList" :key="participantUser.managerUserId || index">
                                                <div class="userInfo">
                                                    <div class="specialUserImg">
                                                        <img :src="participantUser.managerUserPhoto ? 
                                                        `https://mizecloud-partners.co.kr/employee_img/${participantUser.managerUserPhoto}` : 'https://mizecloud-partners.co.kr/employee_img/default.png'" alt="userProfileImg"/>
                                                    </div>
                                                    <div class="specialUserName">{{ participantUser.managerUserName }}</div>
                                                </div>
                                                <span class="xBtn" @click="removeParticipant(index)"><i class="bi bi-x-lg"></i></span>
                                            </div>
                                        </div>
                                        <span class="underlineBtn"  @click="searchParticipantName = ''; isParticipantPopupOpen = !isParticipantPopupOpen">참석자 추가</span>
                                        <!-- ▼ 담당자 추가 시 class="active" 추가 -> 나타남 -->
                                        <div class="peopleSelectBox" :class="{ active: isParticipantPopupOpen }">
                                          <div class="peopleSearch formRightIcon">
                                            <input type="text" :value="searchParticipantName" @input="handleParticipantInput" id="peopleSearch" placeholder="검색어를 입력해주세요"/>
                                            <span class="formIcon">
                                              <i class="bi bi-search"></i>
                                            </span>
                                          </div>
                                          <div class="peopleListBox">
                                            <div class="peopleList" ref="peopleList">
                                              <div class="peopleItem" v-for="person in searchParticipantUserList" :key="person.managerUserId" @click="selectScheduleParticipant(person)">
                                                <div class="specialUserInfo">
                                                  <div class="specialUserImg">
                                                    <img
                                                        :src="
                                                        person.managerUserPhoto
                                                            ? `https://mizecloud-partners.co.kr/employee_img/${person.managerUserPhoto}`
                                                            : 'https://mizecloud-partners.co.kr/employee_img/default.png'
                                                        "
                                                        alt="profileImg"
                                                    />
                                                  </div>
                                                  <div class="specialUserDes">
                                                    <div class="specialUserName">{{ person.managerUserName }} <span>{{ person.managerUserPosition }}</span></div>
                                                    <div class="specialUserTeam">{{ person.managerUserDept }}</div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div v-if="searchParticipantUserList.length === 0 && searchParticipantName.trim() !== ''" class="noResult">
                                                  검색 결과가 없습니다.
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="detailItem locate">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-geo-alt"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <div class="detailItemDes">
                                            <input type="text" v-model="scheduleLocation" ref="scheduleLocation" placeholder="장소를 입력하세요.">
                                        </div>
                                    </div>
                                </div>

                                
                                <!-- ▼ 줌 링크 추가 기능은 유료버전에만 해당되어 일단 항목만 넣어놓겠습니다 ▼ -->
                                <div class="detailItem zoomLink">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-camera-video"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <span class="underlineBtn" @click="showAlert()">화상회의 추가</span>
                                    </div>
                                </div>

                                <div class="detailItem alretTime">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-bell"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                            <select id="options" v-model="beforeAlarm">
                                                <option value="0">없음</option>
                                                <option value="10">10분 전 미리 알림</option>
                                                <option value="30">30분 전 미리 알림</option>
                                                <option value="60">1시간 전 미리 알림</option>
                                                <option value="120">2시간 전 미리 알림</option>
                                                <option value="180">3시간 전 미리 알림</option>
                                                <option value="1440">1일 전 미리 알림</option>
                                                <option value="2880">2일 전 미리 알림</option>
                                                <option value="10080">7일 전 미리 알림</option>
                                            </select>
                                    </div>
                                </div>

                            </div>
                            <div class="modalFeedDesInputBox">
                                <textarea name="" id="" class="modalFeedDesInput" v-model="scheduleContent" ref="scheduleContent"  placeholder="내용을 작성하세요."></textarea>
                            </div>
                        </div>
                        <div class="modalFooter">
                            <div class="modalFooterBtnBox">
                                <div class="btnBox">
                                    <i class="bi bi-fonts"></i>
                                    <i class="bi bi-paperclip"></i>
                                    <i class="bi bi-geo-alt"></i>
                                </div>
                            </div>
                            <div class="modalFooterBtnBox">
                                <div class="dropdown">
                                    <div class="dropdown-button" @click="toggleDropdown">{{ selectedOption }}</div>
                                    <div class="dropdown-menu" v-show="isDropdownOpen">
                                        <div class="dropdown-item" @click="selectItem('전체공개')">전체공개</div>
                                        <div class="dropdown-item" @click="selectItem('프로젝트 관리자만')">프로젝트 관리자만</div>
                                    </div>
                                </div>
                                <div class="preStorage">
                                  <span>임시저장</span>
                                  <span class="gap"></span>
                                  <span><b>0</b></span>
                                </div>
                                <button class="blueBtn" @click="addSchedule">등록</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 항목 클릭 시 일정 상세보기 : .active -->
                <div class="specialSideModalBg detailViewProjectSideModal">
                  <div class="specialSideModalBox detailViewProject">
                      <div class="projectListItem taskFeed">
                        <div class="specialSideModalTitleBox">
                          <div class="modalTitle">
                            <i class="bi bi-app"></i>
                            <h5>프로젝트명</h5>
                          </div>
                          <div class="modalHeaderBtnBox">
                            <span class="closeBtn"><i class="bi bi-x-lg"></i></span>
                          </div>
                        </div>
                        <div class="feedListItemDes">
                          <div class="feedListItemHeader">
                            <div class="writterInfo">
                              <div class="specialUserImg">
                                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                              </div>
                            <div class="specialUserName">홍길동</div>
                            <div class="writeTime">2025-04-09 13:04</div>
                          </div>
                          <div class="feedHeaderBtnBox">
                            <div class="simpleBtn">
                              <i class="bi bi-pin"></i>
                            </div>
                            <div class="simpleBtn">
                              <i class="bi bi-three-dots-vertical"></i>
                            </div>
                          </div>
                        </div>
                        <div class="feedListItemBody taskFeedItem">
                          <div class="feedBodyTaskTitle">
                            <div class="feedBodyTitle">업무 제목</div>
                            <span class="taskNumber biglineBtn">업무번호 7</span>    
                          </div>
                          <div class="feedBodyDetail">
                            <div class="detailItem status">
                              <div class="detailItemIcon">
                                <i class="bi bi-bar-chart-steps"></i>
                              </div>
                              <div class="detailItemDes">
                                <div class="statusBtnBox">
                                  <div class="statusBtn request active">요청</div>
                                </div>
                              </div>
                            </div>
                            <div class="detailItem manager">
                              <div class="detailItemIcon">
                                <i class="bi bi-person"></i>
                              </div>
                              <div class="flexAlignCenter">
                                <div class="detailItemDes">
                                  <div class="selectedUser">
                                    <div class="userInfo">
                                      <div class="specialUserImg">
                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                      </div>
                                      <div class="specialUserName">홍길동</div>
                                    </div>
                                    <span class="xBtn"><i class="bi bi-x-lg"></i></span>
                                  </div>
                                </div>
                                <span class="underlineBtn">담당자 변경</span>
                              </div>
                            </div>
                            <div class="detailItem endDate">
                              <div class="detailItemIcon">
                                <i class="bi bi-calendar"></i>
                              </div>
                            <div class="flexAlignCenter">
                              <div class="detailItemDes">
                                <div class="textBox">
                                  <span>2025-04-30 (수) 까지</span>
                                  <span class="xBtn"><i class="bi bi-x-lg"></i></span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="subTaskListBox">
                            <button class="biglineBtn">
                              <i class="bi bi-plus-lg"></i>
                              <span>항목추가입력</span>
                            </button>
                          </div>
                        </div>
                        <div class="feedBodyTextDetail">글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 </div>
                          <div class="feedBodySubTaskBox">
                            <div class="subTaskTitleBox">
                              <span class="subTaskIcon"><i class="bi bi-list-task"></i></span>
                              <span class="subTaskTitle">하위업무</span>
                            </div>
                          <div class="subTaskListBox">
                            <button class="biglineBtn">
                              <i class="bi bi-plus-lg"></i>
                              <span>하위업무 추가</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="feedListItemFooter">
                        <div class="feedFooterLeft">
                          <div class="simpleBtn">
                            <i class="bi bi-hand-thumbs-up"></i>
                            <span>좋아요</span>
                          </div>
                          <div class="simpleBtn">
                            <i class="bi bi-bookmark"></i>
                            <span>북마크</span>
                          </div>
                          <div class="simpleBtn">
                            <i class="bi bi-clock-history"></i>
                            <span>다시 알림</span>
                          </div>
                        </div>
                        <div class="feedFooterRight">
                          <div class="simpleBtn notBtn">
                            <span>읽음</span>
                            <span><b>1</b></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- 댓글 -->
                    <div class="feedListItemComment">
                        <div class="feedCommentHeader">
                            <span class="lineBtn active">
                                <span>전체</span>
                                <span><b>6</b></span>
                            </span>
                            <span class="lineBtn">
                                <span>댓글</span>
                                <span><b>6</b></span>
                            </span>
                        </div>
                        <div class="moreComment txtBtn">이전 댓글 더보기 (1)</div>
                        <div class="feedCommentBody">
                            <div class="feedCommentItem noreply">
                                <div class="commentLeft">
                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                </div>
                                <div class="commentRight">
                                    <div class="commentHeader">
                                        <div class="commentHeaderUser">
                                            <div class="specialUserName">홍길동</div>
                                            <div class="writeTime">2025-04-09 13:04</div>
                                        </div>
                                        <div class="commentHeaderBtnBox">
                                            <div id="commentEdit" class="txtBtn">수정</div>
                                            <div id="commentDelet" class="txtBtn">삭제</div>
                                        </div>
                                    </div>
                                    <div class="commentBody">
                                        댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 
                                    </div>
                                    <div class="commentFooter">
                                        <div id="reply" class="simpleBtn">
                                            <i class="bi bi-arrow-return-right"></i>
                                            <span>댓글</span>
                                        </div>
                                        <div id="like" class="simpleBtn">
                                            <i class="bi bi-hand-thumbs-up"></i>
                                            <span>좋아요</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="feedCommentItem noreply">
                                <div class="commentLeft">
                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                </div>
                                <div class="commentRight">
                                    <div class="commentHeader">
                                        <div class="commentHeaderUser">
                                            <div class="specialUserName">홍길동</div>
                                            <div class="writeTime">2025-04-09 13:04</div>
                                        </div>
                                        <div class="commentHeaderBtnBox">
                                            <div id="commentEdit" class="txtBtn">수정</div>
                                            <div id="commentDelet" class="txtBtn">삭제</div>
                                        </div>
                                    </div>
                                    <div class="commentBody">
                                        댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 
                                    </div>
                                    <div class="commentFooter">
                                        <div id="reply" class="simpleBtn">
                                            <i class="bi bi-arrow-return-right"></i>
                                            <span>댓글</span>
                                        </div>
                                        <div id="like" class="simpleBtn">
                                            <i class="bi bi-hand-thumbs-up"></i>
                                            <span>좋아요</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="feedCommentItem noreply">
                                <div class="commentLeft">
                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                </div>
                                <div class="commentRight">
                                    <div class="commentHeader">
                                        <div class="commentHeaderUser">
                                            <div class="specialUserName">홍길동</div>
                                            <div class="writeTime">2025-04-09 13:04</div>
                                        </div>
                                        <div class="commentHeaderBtnBox">
                                            <div id="commentEdit" class="txtBtn">수정</div>
                                            <div id="commentDelet" class="txtBtn">삭제</div>
                                        </div>
                                    </div>
                                    <div class="commentBody">
                                        댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 
                                    </div>
                                    <div class="commentFooter">
                                        <div id="reply" class="simpleBtn">
                                            <i class="bi bi-arrow-return-right"></i>
                                            <span>댓글</span>
                                        </div>
                                        <div id="like" class="simpleBtn">
                                            <i class="bi bi-hand-thumbs-up"></i>
                                            <span>좋아요</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="feedCommentItem noreply">
                                <div class="commentLeft">
                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                </div>
                                <div class="commentRight">
                                    <div class="commentHeader">
                                        <div class="commentHeaderUser">
                                            <div class="specialUserName">홍길동</div>
                                            <div class="writeTime">2025-04-09 13:04</div>
                                        </div>
                                        <div class="commentHeaderBtnBox">
                                            <div id="commentEdit" class="txtBtn">수정</div>
                                            <div id="commentDelet" class="txtBtn">삭제</div>
                                        </div>
                                    </div>
                                    <div class="commentBody">
                                        댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 
                                    </div>
                                    <div class="commentFooter">
                                        <div id="reply" class="simpleBtn">
                                            <i class="bi bi-arrow-return-right"></i>
                                            <span>댓글</span>
                                        </div>
                                        <div id="like" class="simpleBtn">
                                            <i class="bi bi-hand-thumbs-up"></i>
                                            <span>좋아요</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="feedCommentFooter leaveComment">
                            <div class="leaveCommentUser">
                                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">                                                    
                            </div>
                            <div class="leaveCommentInput formRightIcon">
                                <input type="text" placeholder="줄바꿈 Shift + Enter / 입력 Enter 입니다.">
                                <span class="formIcon">
                                    <i class="bi bi-paperclip"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                  </div>
              </div>
            </div>

</template>

<script>
import apiClient from "@/apiClient";
import { useToast } from "vue-toastification";
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';

export default {  
  setup() {
    const toast = useToast();
    return { toast };
  },
  props: ['projectId'],
  name: "ReportCalendar",
  components: { DatePicker },
  data() {
    return {
      subMenuGroups: [
        {
          title: "프로젝트 그룹 1",
          open: true,
          projects: ["프로젝트명 A", "프로젝트명 B", "프로젝트명 C"],
        },
        {
          title: "프로젝트 그룹 2",
          open: true,
          projects: ["프로젝트명 D", "프로젝트명 E"],
        },
      ],         
      showAddPostPopup: false,      // 글 작성 팝업
      showAddTaskPopup: false,      // 업무 작성 팝업
      showAddSchedulePopup: false,  // 일정 작성 팝업
      projectInfo: [],              // 해당 프로젝트 정보
      projectName: '',              // 해당 프로젝트명
      selectedViewType: 'P',        // 전체공개여부 설정(default는 'P(Public)' => 전체공개 / 'A(Admin)' => 프로젝트 관리자만)
      alertMsg: {
        commingSoon:  '준비중입니다.',
        postSubject: '글 제목을 입력해주세요.',
        postContent: '글 내용을 입력해주세요.', 
        successPostAdd: '글 성공적으로 등록되었습니다.',
        failPostAdd: '글 등록 중 오류가 발생했습니다.',
        successTaskAdd: '업무가 성공적으로 등록되었습니다.',
        failTaskAdd: '업무 등록 중 오류가 발생했습니다.',
        successScheduleAdd: '일정이 성공적으로 등록되었습니다.',
        failScheduleAdd: '일정 등록 중 오류가 발생했습니다.',
        taskStartDateValid: '시작일은 마감일보다 이후일 수 없습니다.',
        taskEndDateValid: '마감일은 시작일보다 이전일 수 없습니다.',
        taskSubject: '업무 제목을 입력해주세요.',
        taskStatus: '업무 상태를 선택해주세요.',
        taskManager: '담당자를 추가해주세요.',
        taskStartDate: '시작일을 선택해주세요.',
        taskEndDate: '마감일을 선택해주세요.',
        taskContent: '업무 내용을 입력해주세요.',
        scheduleSubject:  '일정 제목을 입력해주세요.',
        scheduleStartDate: '일정 시작일을 선택해주세요.',
        scheduleEndDate: '일정 마감일을 선택해주세요.',
        scheduleContent:  '일정 내용을 입력해주세요.',
        scheduleParticipant: '참석자를 선택해주세요.',
        scheduleStartDateValidNow: '시작일은 현재시간보다 이후이어야 합니다.',
        scheduleStartDateValid: '시작일은 마감일보다 이후일 수 없습니다.',
        scheduleEndDateValidNow: '마감일은 현재시간보다 이후이어야 합니다.',
        scheduleEndDateValid: '마감일은 시작일보다 이전일 수 없습니다.',
        checkAllday: '시작일과 마감일을 먼저 선택해주세요.'
      },
      priorities: [
            { id: 4, text: '낮음', class: 'priority4', icon: 'bi-caret-down-fill', value: 'L'},
            { id: 3, text: '보통', class: 'priority3', icon: 'bi-caret-right-fill', value: 'M' },
            { id: 2, text: '높음', class: 'priority2', icon: 'bi-caret-up-fill', value: 'H' },
            { id: 1, text: '긴급', class: 'priority1', icon: 'bi-fire', value: 'U' }
      ],
      subTaskPriorities: [
            { id: 4, text: '낮음', class: 'priority4', icon: 'bi-caret-down-fill', color: 'var(--txt6)', value: 'L' },
            { id: 3, text: '보통', class: 'priority3', icon: 'bi-caret-right-fill', color: 'var(--mizeBlue)', value: 'M' },
            { id: 2, text: '높음', class: 'priority2', icon: 'bi-caret-up-fill', color: 'var(--pointYellow)', value: 'H' },
            { id: 1, text: '긴급', class: 'priority1', icon: 'bi-fire', color: 'var(--pointRed)', value: 'U' }
      ],
      statusMap: {
        'R': '요청',
        'P': '진행',
        'F': '피드백',
        'C': '완료',
        'H': '보류'
      },
      taskProgress: 0,
      isDropdownOpen: false,
      selectedOption: "전체공개",      
      selectedTaskStatus: '',           // 업무작성 팝업 > 업무상태 => 요청 : R(Request) / 진행 : P(Progress) / 피드백 : F(Feedback) / 완료 : C(Completed) / 보류 : H(Hold)
      isTaskStartDatePickerOpen: false, // 업무작성 팝업 > 시작일 선택 팝업 오픈 여부
      isTaskEndDatePickerOpen: false,   // 업무작성 팝업 > 종료일 선택 팝업 오픈 여부
      isManagerPopupOpen: false,        // 담당자 추가
      isPriorityPopupOpen: false,       // 우선순위 추가
      isPriorityProgressOpen: false,    // 항목추가입력 클릭 시, 우선순위 & 진행률(%) 영역
      searchManagerName: "",            // 담당자 추가 시, 검색할 이름 입력값
      searchManagerUserList: [],        // 담당자 추가 시, 검색된 사용자 리스트
      selectedTaskManager: "",          // 업무작성 팝업 > 선택된 담당자 정보
      selectedTaskStartDate: null,      // 업무작성 팝업 > 선택된 시작일
      selectedTaskEndDate: null,        // 업무작성 팝업 > 선택된 마감일
      selectedPriority: null,           // 업무작성 팝업 > 선택된 우선순위
      subTaskList: [],                  // 업무작성 팝업 > 하위 업무 목록 배열

      isScheduleStartDatePickerOpen: false, // 일정작성 팝업 > 시작일 선택 팝업 오픈 여부
      isScheduleEndDatePickerOpen: false,   // 일정작성 팝업 > 종료일 선택 팝업 오픈 여부
      isParticipantPopupOpen: false,        // 참석자 추가
      searchParticipantName: "",            // 참석자 추가 시, 검색할 이름 입력값
      searchParticipantUserList: [],        // 참석자 추가 시, 검색된 사용자 리스트
      selectedParticipantUserList: [],      // 일정작성 팝업 > 선택된 참석자들 정보
      selectedScheduleStartDate: null,      // 일정작성 팝업 > 선택된 시작일
      selectedScheduleEndDate: null,        // 일정작성 팝업 > 선택된 마감일
      isAllDay: 'N',                        // 종일여부
      beforeAlarm: 0,                       // 미리알림(분단위)
      isFilterOpen: false,                  // 필터 상태 변수
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth(),
      scheduleListData:[],
    };
  },
  computed: {
      formattedTaskStartDate() {
          if (!this.selectedTaskStartDate) return '';
          const date = new Date(this.selectedTaskStartDate);
          const options = { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' };
          return date.toLocaleDateString('ko-KR', options).replace(/\s/g, '');
      },
      formattedTaskEndDate() {
          if (!this.selectedTaskEndDate) return '';
          const date = new Date(this.selectedTaskEndDate);
          const options = { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' };
          return date.toLocaleDateString('ko-KR', options).replace(/\s/g, '');
      },
      canCheckAllDay() {            
          return !!this.selectedScheduleStartDate && !!this.selectedScheduleEndDate; 
      },
      calendarTitle() {
        return `${this.currentYear}년 ${this.currentMonth + 1}월`;
      },
      calendarWeeks() {
        const year = this.currentYear;
        const month = this.currentMonth;

        const firstDayOfMonth = new Date(year, month, 1);
        const lastDayOfMonth = new Date(year, month + 1, 0);

        const weeks = [];
        let week = [];

        for (let i = 0; i < firstDayOfMonth.getDay(); i++) {
          week.push(null);
        }

        for (let date = 1; date <= lastDayOfMonth.getDate(); date++) {
          week.push(date);
          if (week.length === 7) {
            weeks.push(week);
            week = [];
          }
        }
        
        while (week.length < 7) {
          week.push(null);
        }
        weeks.push(week);

        return weeks;
      },
      calendarRenderWeeks() {
        return this.calendarWeeks.map(week => ({
          days: week,
          rows: this.buildEventRowsForWeek(week)
        }));
      },
  },
  watch: {
    searchManagerName(newVal) {
        if (newVal.trim() === "") {
            this.searchManagerUserList = [];
            return;
        }
        this.searchManager(newVal);     
    },
    searchParticipantName(newVal) {
        if (newVal.trim() === "") {
            this.searchParticipantUserList = [];
            return;
        }
        this.searchParticipant(newVal);     
    },
    isAllDay(val) {
        if (!this.scheduleStartDateTime || !this.scheduleEndDateTime) return;

        if (val === 'Y') {
            const startDate = this.scheduleStartDateTime.slice(0, 10);
            const endDate = this.scheduleEndDateTime.slice(0, 10);
            this.selectedScheduleStartDate = this.scheduleStartDateTime = startDate + 'T00:00';
            this.selectedScheduleEndDate = this.scheduleEndDateTime = endDate + 'T23:59';
        }
    }
  },
  methods: {
    toggleGroup(index) {
      this.subMenuGroups[index].open = !this.subMenuGroups[index].open;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    formatDateToYYYYMMDD(date) {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    selectItem(option) {
      this.selectedOption = option;
      this.isDropdownOpen = false;
      if (option === "전체공개") {
        this.selectedViewType = "P";
      } else if (option === "프로젝트 관리자만") {
        this.selectedViewType = "A";
      } 
    },
    handleTaskStartDateChange(date) {
        if (this.selectedTaskEndDate && date > this.selectedTaskEndDate) {
            this.toast.error(this.alertMsg['taskStartDateValid'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
            this.selectedTaskStartDate = null;
        } else {
            this.selectedTaskStartDate = date;
        }
        this.isTaskStartDatePickerOpen = false;
    },
    handleTaskEndDateChange(date) {
        if (this.selectedTaskStartDate && date < this.selectedTaskStartDate) {
            this.toast.error(this.alertMsg['taskEndDateValid'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
            this.selectedTaskEndDate = null;
        } else {
            this.selectedTaskEndDate = date;
        }
        this.isTaskEndDatePickerOpen = false;
    },    
    handleScheduleStartDateChange() {
        if (!this.scheduleStartDateTime) return;

        const start = new Date(this.scheduleStartDateTime);
        const end = this.scheduleEndDateTime ? new Date(this.scheduleEndDateTime) : null;
        const now = new Date();
        
        if (start < now) {
            this.toast.error(this.alertMsg['scheduleStartDateValidNow'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });

            this.$refs.scheduleStartDateTime.value = '';
            this.scheduleStartDateTime = '';
            return;
        }

        if (end && start > end) {
            this.toast.error(this.alertMsg['scheduleStartDateValid'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });

            this.$refs.scheduleStartDateTime.value = '';
            this.scheduleStartDateTime = '';
            return;
        }

        this.selectedScheduleStartDate = this.$refs.scheduleStartDateTime.value;
    },
    handleScheduleEndDateChange() {
        if (!this.scheduleEndDateTime) return;

        const end = new Date(this.scheduleEndDateTime);
        const now = new Date();

        if (end < now) {
            this.toast.error(this.alertMsg['scheduleEndDateValidNow'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });

            this.$refs.scheduleEndDateTime.value = '';
            this.scheduleEndDateTime = '';            
            return;
        }

        if (!this.scheduleStartDateTime) return;

        const start = new Date(this.scheduleStartDateTime);

        if (end < start) {
            this.toast.error(this.alertMsg['scheduleEndDateValid'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });

            this.$refs.scheduleEndDateTime.value = '';
            this.scheduleEndDateTime = '';
            return;
        }

        this.selectedScheduleEndDate = this.$refs.scheduleEndDateTime.value;
    },
    navigateProjectMenu(menu) {
        const nameMap = {
            //feed: 'ReportFeed',
            feed: 'ReportList',
            task: 'ReportTask',
            calendar: 'ReportCalendar'
        };

        if (nameMap[menu]) {
            this.$router.push({ name: nameMap[menu], params: { projectId: this.projectId } });
        } else {
            console.warn(`Unknown menu: ${menu}`);
        }
    },
    async getProjectInfo() {
      try {
        const response = await apiClient.post("/api/Project/project-info", {
          ProjectId: this.projectId,
        });

        if (response.status === 200) {
          const data = response.data;
          this.projectInfo = data.project || {};
          this.projectName = data.project.Name;
        }
      } catch (error) {
        console.error("Error fetching projectInfo data:", error);
      }
    },
    async addPost() {
      if (!this.postSubject || this.postSubject.trim() === "") {
        this.toast.error(this.alertMsg['postSubject'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        this.$refs.postSubject.focus();
        return; 
      }
      if (!this.postContent || this.postContent.trim() === "") {
        this.toast.error(this.alertMsg['postContent'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        this.$refs.postContent.focus();
        return; 
      }

      try {
          const response = await apiClient.post(`/api/Post/post-add`, {
            LoginUserId: localStorage.getItem("userid"),
            ProjectId: this.projectId,
            Subject: this.postSubject,
            Content: this.postContent,
            ViewType: this.selectedViewType
          });

          if (response.status === 200) {
            this.toast.success(this.alertMsg['successPostAdd'], {
              position: "top-center", // 메시지 위치
              timeout: 1500, // 3초 동안 표시
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: true, // 진행 표시줄 숨기기
              closeButton: false, // X 버튼 숨기기
            });

            this.showAddPostPopup = false;
            this.initPostPopupVaule();
          }
      } catch (error) {
        console.error("Error adding post data:", error);
        this.toast.error(this.alertMsg['failPostAdd'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
      }
    },
    async addTask() {
      if (!this.taskSubject || this.taskSubject.trim() === "") {
        this.toast.error(this.alertMsg['taskSubject'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });

        this.$refs.taskSubject.focus();
        return; 
      }
      if (!this.selectedTaskStatus) {
        this.toast.error(this.alertMsg['taskStatus'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedTaskManager) {
        this.toast.error(this.alertMsg['taskManager'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedTaskStartDate) {
        this.toast.error(this.alertMsg['taskStartDate'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedTaskEndDate) {
        this.toast.error(this.alertMsg['taskEndDate'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.taskContent || this.taskContent.trim() === "") {
        this.toast.error(this.alertMsg['taskContent'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });

        this.$refs.taskContent.focus();        
        return; 
      }

      try {
          const subTaskListData = Array.isArray(this.subTaskList)
            ? this.subTaskList
            .filter(subtask => subtask.name && subtask.name.trim() !== '')
            .map(subtask => ({
                SubTaskSubject: subtask.name,
                SubTaskStatus: subtask.status,
                SubTaskEndDate: this.formatDateToYYYYMMDD(subtask.subTaskEndDate),
                SubTaskPriority: subtask.selectedSubTaskPriority?.value || null,
                SubTaskManagerUserId: subtask.selectedSubTaskManager?.managerUserId || null
                }))
            : [];
            
          const response = await apiClient.post(`/api/Task/task-add`, {
            LoginUserId: localStorage.getItem("userid"),
            ProjectId: this.projectId,
            Subject: this.taskSubject,
            ManagerUserId: this.selectedTaskManager.managerUserId,
            Status: this.selectedTaskStatus,
            TaskStartDate : this.formatDateToYYYYMMDD(this.selectedTaskStartDate),
            TaskEndDate : this.formatDateToYYYYMMDD(this.selectedTaskEndDate),
            Priority: this.selectedPriority?.value || null,       
            ProgressNum: this.taskProgress,            
            Content: this.taskContent,
            ViewType: this.selectedViewType,
            SubTaskList: subTaskListData
          });

          if (response.status === 200) {
            this.toast.success(this.alertMsg['successTaskAdd'], {
              position: "top-center", // 메시지 위치
              timeout: 1500, // 3초 동안 표시
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: true, // 진행 표시줄 숨기기
              closeButton: false, // X 버튼 숨기기
            });

            this.showAddTaskPopup = false;
            this.initTaskPopupVaule();
            this.getScheduleList();
          }
      } catch (error) {
        console.error("Error adding task data:", error);
        this.toast.error(this.alertMsg['failTaskAdd'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
      }
    },
    async addSchedule() {
      if (!this.scheduleSubject || this.scheduleSubject.trim() === "") {
        this.toast.error(this.alertMsg['scheduleSubject'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });

        this.$refs.scheduleSubject.focus();
        return; 
      }
      if (!this.selectedScheduleStartDate) {
        this.toast.error(this.alertMsg['scheduleStartDate'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedScheduleEndDate) {
        this.toast.error(this.alertMsg['scheduleEndDate'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedParticipantUserList.length) {
        this.toast.error(this.alertMsg['scheduleParticipant'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }  
      if (!this.scheduleContent || this.scheduleContent.trim() === "") {
        this.toast.error(this.alertMsg['scheduleContent'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });

        this.$refs.scheduleContent.focus();        
        return; 
      }

      try {
          const participantListData = Array.isArray(this.selectedParticipantUserList)
            ? this.selectedParticipantUserList.map(participantUser => ({
                    ScheduleParticipantUserId: participantUser.managerUserId
                }))
            : [];
            
          const response = await apiClient.post(`/api/Schedule/schedule-add`, {
            LoginUserId: localStorage.getItem("userid"),
            ProjectId: this.projectId,
            Subject: this.scheduleSubject,
            StartDtm : this.selectedScheduleStartDate,
            EndDtm : this.selectedScheduleEndDate,
            AlldayYn: this.isAllDay,
            Location: this.scheduleLocation ? this.scheduleLocation : '',
            BeforeAlarm: this.beforeAlarm,
            Content: this.scheduleContent,
            ParticipantList: participantListData
          });

          if (response.status === 200) {
            this.toast.success(this.alertMsg['successScheduleAdd'], {
              position: "top-center", // 메시지 위치
              timeout: 1500, // 3초 동안 표시
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: true, // 진행 표시줄 숨기기
              closeButton: false, // X 버튼 숨기기
            });

            this.showAddSchedulePopup = false;
            this.initSchedulePopupVaule();
            this.getScheduleList();
          }
      } catch (error) {
        console.error("Error adding task data:", error);
        this.toast.error(this.alertMsg['failScheduleAdd'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
      }
    },
    async searchManager(keyword) {
      try {
        const response = await apiClient.post("/api/Task/manager-search", {
          ManagerUserName: keyword 
        });
        
        if (response.status === 200) {
            const data = JSON.parse(response.data);
            this.searchManagerUserList = Array.isArray(data.data) ? data.data : [];
        }
      } catch (error) {
        console.error("Error fetching managerUserList data:", error);
      }
    },
    async searchParticipant(keyword) {
      try {
        const response = await apiClient.post("/api/Task/manager-search", {
          ManagerUserName: keyword 
        });
        
        if (response.status === 200) {
            const data = JSON.parse(response.data);
            this.searchParticipantUserList = Array.isArray(data.data) ? data.data : [];
        }
      } catch (error) {
        console.error("Error fetching participantUserList data:", error);
      }
    },
    async getScheduleList() {
      try {
        const response = await apiClient.post("/api/Schedule/schedule-list", {
          OrderType: "",
          ProjectId: this.projectId,
          SearchYearMonth: this.currentYear + '-' + (this.currentMonth + 1),
          SearchKey: this.searchSubject
        });

        if (response.status === 200) {
          const result = JSON.parse(response.data);
          this.scheduleListData = Array.isArray(result.data) ? result.data : [];
        }
      } catch (error) {
        console.error("Error fetching scheduleList data:", error);
      }
    },
    selectTaskManager(person) {
        this.selectedTaskManager = person;
        this.isManagerPopupOpen = false;
        this.searchManagerName = '';
    },
    selectPriority(priority) {
        this.selectedPriority = priority;
        this.isPriorityPopupOpen = false;
    },    
    selectScheduleParticipant(person) {
        const isExist = this.selectedParticipantUserList.some(
            user => user.managerUserId === person.managerUserId
        );

        if (!isExist) {
            this.selectedParticipantUserList.push(person);
        }
        
        this.isParticipantPopupOpen = false;
        this.searchParticipantName = '';
    },
    removeParticipant(index) {
        this.selectedParticipantUserList.splice(index, 1);
    },
    handleManagerInput(event) {
        this.searchManagerName = event.target.value;
    },
    handleParticipantInput(event) {
        this.searchParticipantName = event.target.value;
    },
    checkAllDayClick(e) {
        if (!this.canCheckAllDay) {
            e.preventDefault();
            this.toast.error(this.alertMsg['checkAllday'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
        }
    },
    initPostPopupVaule() {
      this.postSubject = this.postContent = '';
      this.selectedViewType = 'P';
    },
    initTaskPopupVaule() {
      this.taskSubject = '';
      this.selectedTaskStatus = '';
      this.selectedTaskManager = '';
      this.selectedTaskStartDate = '';
      this.selectedTaskEndDate = '';
      this.selectedPriority = '';
      this.isPriorityProgressOpen = false;
      this.taskProgress = 0;
      this.taskContent = '';
      this.selectedViewType = "P";
      this.subTaskList = [];
    },
    initSchedulePopupVaule() {
      this.scheduleSubject = '';
      this.selectedParticipantUserList = [];
      this.scheduleStartDateTime = '';
      this.scheduleEndDateTime = '';
      this.selectedScheduleStartDate = '';
      this.selectedScheduleEndDate = '';
      this.scheduleLocation = '';
      this.scheduleContent = '';
      this.isAllDay = 'N';
      this.beforeAlarm = 0;
      this.selectedViewType = "P";
    },
    initAllPopup(type) {
      ['showAddPostPopup', 'showAddTaskPopup', 'showAddSchedulePopup'].forEach(key => {
        this[key] = false;
      });

      const map = {
        post: 'showAddPostPopup',
        task: 'showAddTaskPopup',
        schedule: 'showAddSchedulePopup',
      };

      if (map[type]) {
        this[map[type]] = true;
      }

      this.initPostPopupVaule();
      this.initTaskPopupVaule();
      this.initSchedulePopupVaule();
    },
    updateTaskProgress(event) {
        this.taskProgress = Number(event.target.value);
    },
    addSubTask() {
        const newSubTask = {
            id: Date.now(),
            status: 'R',
            name: '',
            isDatePickerOpen: false,
            subTaskEndDate: null,
            isSubTaskPriorityPopupOpen: false,
            selectedSubTaskPriority: null,
            isSubTaskManagerPopupOpen: false,
            selectedSubTaskManager: null,
        };
        
        this.subTaskList.push(newSubTask);

        this.$nextTick(() => {
            let el = this.$refs['subtask_' + newSubTask.id];

            if (Array.isArray(el)) el = el[0];
            if (el) el.focus();
        });
    },    
    handleEnter() {
        this.addSubTask();

        this.$nextTick(() => {
            const last = this.subTaskList[this.subTaskList.length - 1];
            const refName = 'subtask_' + last.id;

            let input = this.$refs[refName];

            if (Array.isArray(input)) input = input[0];

            if (input) {
                if (typeof input.focus === 'function') {
                    input.focus();
                } else if (input.$el && typeof input.$el.focus === 'function') {
                    input.$el.focus();
                }
            }
        });
    },
    toggleDatePicker(clickedSubTask) {        
        if (clickedSubTask.isDatePickerOpen) {
            clickedSubTask.isDatePickerOpen = false;
            return;
        }

        this.subTaskList.forEach(subTask => {
            subTask.isDatePickerOpen = false;
            subTask.isSubTaskPriorityPopupOpen = false;
            subTask.isSubTaskManagerPopupOpen = false;
        });

        this.$nextTick(() => {
            clickedSubTask.isDatePickerOpen = true;
        });
    },
    togglePriorityPopup(clickedSubTask) {    
        this.subTaskList.forEach(subTask => {
            subTask.isDatePickerOpen = false;
            subTask.isSubTaskManagerPopupOpen = false;

            if (subTask !== clickedSubTask) {
                subTask.isSubTaskPriorityPopupOpen = false;
            }
        });

        clickedSubTask.isSubTaskPriorityPopupOpen = !clickedSubTask.isSubTaskPriorityPopupOpen;
    },
    toggleManagerPopup(clickedSubTask) {
        this.searchManagerName = '';
        this.subTaskList.forEach(subTask => {
            subTask.isDatePickerOpen = false;
            subTask.isSubTaskPriorityPopupOpen = false;

            if (subTask !== clickedSubTask) {
                subTask.isSubTaskManagerPopupOpen = false;
            }
        });

        clickedSubTask.isSubTaskManagerPopupOpen = !clickedSubTask.isSubTaskManagerPopupOpen;
    },
    selectSubTaskPriority(subTask, priority) {
        subTask.selectedSubTaskPriority = priority;
        subTask.isSubTaskPriorityPopupOpen = false;
    },
    selectSubTaskManager(subTask, person) {
        subTask.selectedSubTaskManager = person;
        subTask.isSubTaskManagerPopupOpen = false;
    },
    showAlert() {
        this.toast.error(this.alertMsg['commingSoon'], {
            position: "top-center", // 메시지 위치
            timeout: 1500, // 3초 동안 표시
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: true, // 진행 표시줄 숨기기
            closeButton: false, // X 버튼 숨기기
        });
    },
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;
    },
    goPrevMonth() {
      if (this.currentMonth === 0) {
        this.currentYear--;
        this.currentMonth = 11;
      } else {
        this.currentMonth--;
      }
    },
    goNextMonth() {
      if (this.currentMonth === 11) {
        this.currentYear++;
        this.currentMonth = 0;
      } else {
        this.currentMonth++;
      }
    },
    goToday() {
      const now = new Date();
      this.currentYear = now.getFullYear();
      this.currentMonth = now.getMonth();
    },
    formatTime(dt) {
      const d = new Date(dt);
      return `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
    },
    normalizeDate(d) {
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    },
    buildEventRowsForWeek(weekDays) {
  const rows = [];

  const validWeekDays = weekDays
    .filter(d => d !== null)
    .map(dayNum => new Date(this.currentYear, this.currentMonth, dayNum));

  if (validWeekDays.length === 0) return rows;

  const weekStart = this.normalizeDate(validWeekDays[0]);
  const weekEnd = this.normalizeDate(validWeekDays[validWeekDays.length - 1]);

  const weekEvents = this.scheduleListData.filter(ev => {
    const start = new Date(ev.startDtm);
    const end = new Date(ev.endDtm);
    return end >= weekStart && start <= weekEnd;
  });

  weekEvents.forEach(ev => {
    const start = this.normalizeDate(new Date(ev.startDtm));
    const end = this.normalizeDate(new Date(ev.endDtm));

    const realStart = start < weekStart ? weekStart : start;
    const realEnd = end > weekEnd ? weekEnd : end;

    const dayMs = 86400000;
    const startIndex = Math.floor((realStart - weekStart) / dayMs);
    let span = Math.floor((realEnd - realStart) / dayMs) + 1;
    if (span < 1) span = 1;

    if (span === 1) {
      // ✅ 하루짜리 이벤트는 무조건 첫 번째 row에 쌓는다
      let targetRow = rows[0];
      if (!targetRow) {
        targetRow = [];
        rows.push(targetRow);
      }

      const existingBar = targetRow.find(b => b.start === startIndex && b.span === 1);
      if (existingBar) {
        if (Array.isArray(existingBar.event)) {
          existingBar.event.push(ev);
        } else {
          existingBar.event = [existingBar.event, ev];
        }
      } else {
        targetRow.push({ start: startIndex, span: 1, event: [ev] });
      }
    } else {
      // ✅ 멀티데이 이벤트는 기존 로직대로 isOccupied 체크 후 배치
      const bar = { start: startIndex, span, event: ev };
      let placed = false;
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        if (!this.isOccupied(row, bar.start, bar.span)) {
          row.push(bar);
          placed = true;
          break;
        }
      }
      if (!placed) {
        rows.push([bar]);
      }
    }
  });

  return rows;
},

    isOccupied(row, start, span) {
      return row.some(b =>
        start < b.start + b.span &&
        start + span > b.start
      );
    },
    isBarStart(row, col) {
      const hit = row.some(b => b.start === col);
      return hit;
    },
    getBar(row, col) {
      const bar = row.find(b => b.start === col);
      return bar;
    },
    isCovered(row, col) {
      const hit = row.some(b => col > b.start && col < b.start + b.span);
      return hit;
    },     
    // 하루에 해당하는 모든 bar 가져오기
    getBars(row, col) {
      return row.filter(b => b.start === col);
    },
    generateRowTds(row) {
  const tds = [];
  let col = 0;
  const maxVisiblePerDay = 3;

  while (col < 7) {
    if (this.isBarStart(row, col)) {
      const bar = this.getBar(row, col);
      const events = Array.isArray(bar.event) ? bar.event : [bar.event];

      const isMulti = !Array.isArray(bar.event); // 단일 이벤트면 멀티데이 가능

      const colspan = isMulti ? bar.span : 1;

      events.slice(0, maxVisiblePerDay).forEach((ev, idx) => {
        tds.push({
          type: 'bar',
          colspan,
          event: ev,
          key: `event-${col}-${idx}`
        });
      });

      const hiddenCount = events.length - maxVisiblePerDay;
      if (hiddenCount > 0) {
        tds.push({
          type: 'more',
          colspan: 1,
          count: hiddenCount,
          key: `more-${col}`
        });
      }

      col += colspan;
    } else if (this.isCovered(row, col)) {
      tds.push({ type: 'skip', key: `skip-${col}` });
      col++;
    } else {
      tds.push({ type: 'empty', key: `empty-${col}` });
      col++;
    }
  }

  return tds;
}

  },
  mounted() {
    this.getProjectInfo();
    this.getScheduleList();
  }
};
</script>

